import queryString, {ParsedQuery} from 'query-string';

export const getQuery = (location: any): ParsedQuery => queryString.parse(location.search) || {};

export const getQueryParam = (location: any, param: string): string | string[] | null => {
  const parsed = location?.search ? queryString.parse(location.search) : {};
  return parsed?.[param];
};

export const getStringQueryParam = (location: any, param: string): string | null => {
  const parsed = location?.search ? queryString.parse(location.search) : {};
  const res = parsed?.[param];
  return typeof res === 'string' ? res : null;
};

export const getNumberQueryParam = (location: any, param: string): number | null => {
  const stringQueryParam = getStringQueryParam(location, param);

  if (stringQueryParam) {
    const numQueryParam = parseInt(stringQueryParam, 10);
    if (!isNaN(numQueryParam)) {
      return numQueryParam;
    }
  }

  return null;
};

export const getNumericState = (location: any, param: string): number | null => {
  const parsed = location?.state ? location?.state : {};
  const res = parsed?.[param];

  if (typeof res === 'number') {
    return res;
  }

  if (typeof res === 'string') {
    const numberVar = parseInt(res, 10);
    if (!Number.isNaN(numberVar)) {
      return numberVar;
    }
  }

  return null;
};
